import 'babel-polyfill';

// Utils and Prereqs
import 'app/easypost_constants';

import 'app/root';

// Static Pages
import 'static-pages/main';



// WEBPACK FOOTER //
// ./main.js